module.exports = __webpack_public_path__ + "static/illustration-requirements-iut@2x-29f25f8c6d08a38f2516fb52b0067d6c.png";